import React, { useEffect, useState } from 'react'
import { BasicHabilitationAccordion } from '../access/HabilitationAccordion'
import { CATCHMENT } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import CatchmentThunk from '../../../../../../catchment/actions/CatchmentThunk'
import CatchmentDto from '../../../../../../catchment/dto/CatchmentDto'

const HabilitationCatchment = ({}) => {
    const dispatch = useDispatch()
    const {
        catchments,
    } = useSelector(store => ({
        catchments: store.CatchmentReducer.catchments,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (catchments.length === 0) {
            Promise.all([
                dispatch(CatchmentThunk.fetchCatchments())
                ]).then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <BasicHabilitationAccordion
            stationType={CATCHMENT}
            title={i18n.catchment}
            stations={catchments}
            isLoaded={isLoaded}
        />
    )
}

HabilitationCatchment.propTypes = {
    catchments: PropTypes.arrayOf(PropTypes.instanceOf(CatchmentDto)),
    fetchCatchments: PropTypes.func,
}

export default HabilitationCatchment